import { render, staticRenderFns } from "./brand-content-hub.vue?vue&type=template&id=2ad435b2"
import script from "./brand-content-hub.vue?vue&type=script&lang=js"
export * from "./brand-content-hub.vue?vue&type=script&lang=js"
import style0 from "./brand-content-hub.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./aos.scss?vue&type=style&index=1&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports